import { FunctionalComponent, h } from '@stencil/core';

import { ChartLegendMarker } from '../../../common/fluid-chart.components';
import { FluidFunctionalComponentProps } from '../../../model/functional/fluid-functional-component-props.interface';

interface PieChartLegendProps extends FluidFunctionalComponentProps {
  legendItems: string[];
  colors: string[];
  orientation: 'horizontal' | 'vertical';
  legendFontSize: number;
}

// ================================================================ //
// -- Public Functional Components

/**
 * Renders a contained pie chart which height and weight can be set
 */
export const ContainedChart = (props: {
  chartHeight: number;
  chartWidth: number;
  chartId: string;
  setRef: (element: HTMLElement) => void;
}) => {
  const { chartHeight, chartWidth, chartId, setRef } = props;
  const chartStyle = {
    height: `${chartHeight}px`,
    width: `${chartWidth}px`,
  };
  return (
    <div class='chart-container' style={chartStyle}>
      <canvas id={chartId} ref={(cr) => setRef(cr)} />
    </div>
  );
};

/**
 * Renders a responsive pie chart which size will fill its container
 */
export const ResponsiveChart = (props: {
  chartId: string;
  setRef: (element: HTMLElement) => void;
}) => {
  const { chartId, setRef } = props;
  return <canvas id={chartId} ref={(cr) => setRef(cr)} />;
};

/**
 * Pie Chart legend
 */
export const PieChartLegend: FunctionalComponent<PieChartLegendProps> = (
  props: PieChartLegendProps
) => {
  const { legendItems, colors, orientation, legendFontSize } = props;
  const svgSize = legendFontSize + 4;

  return (
    <div class={`legend-container orientation-${orientation}`}>
      {legendItems.map((item, index) => (
        <div class='legend-item'>
          <ChartLegendMarker size={svgSize} color={colors[index]} />
          <span
            class='legend-item-label'
            style={{ fontSize: `${legendFontSize}px` }}>
            {item}
          </span>
        </div>
      ))}
    </div>
  );
};
